import { Box, Card, Grid } from "@mui/material";
import PropTypes from "prop-types";
import SoftBox from "components/SoftComponents/SoftBox";
import SoftButton from "components/SoftComponents/SoftButton";
import { useMatch, useNavigate } from "react-router-dom";
import SoftTypography from "components/SoftComponents/SoftTypography";
import InspectionsFormV3 from "modules/inspections/components/InspectionForm";
import { processDeviceData } from "utils/device";
import bksAPI from "services/api/bks";
import inspectionAPI from "modules/inspections/api";
import { useAuth0 } from "@auth0/auth0-react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useSoftUIController } from "hooks/context";
import { wrapper } from "utils/wrapper";

function CreateInspection({ selected_user, all_devices, uuid = false, selected_device = null }) {

    inspectionAPI.loadToken(useAuth0());

    const { mutateAsync } = useMutation({
        mutationFn: (values) => {
            console.log(values)
            return inspectionAPI.addNewInspection(values)
        }
    })

    return <InspectionsFormV3 {...{ selected_user, all_devices, selected_device }} onSubmit={mutateAsync} />
}

CreateInspection.propTypes = {
    selected_user: PropTypes.object.isRequired,
    all_devices: PropTypes.array.isRequired,
    uuid: PropTypes.string,
    selected_device: PropTypes.oneOf([PropTypes.object, PropTypes.bool])
};

export default CreateInspection;
